// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__93t0S","skeleton-animation":"styles_skeleton-animation__KOE_z"};